import React from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Typography,
} from '@mui/material';
import { StyledButton } from '@/components/styled/button';

interface EloquaFormProps {
  //formId: string;
  siteId?: string;
  design: any;
  onSubmit: (data: any) => void;
  fields: any;
}

const EloquaForm: React.FC<EloquaFormProps> = ({
  //formId,
  siteId,
  design,
  onSubmit,
  fields,
}) => {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    // Load Eloqua form script
    const script = document.createElement('script');
    script.src = `https://s${siteId || '2072'}.t.eloqua.com/e/f2.js`;
    script.async = true;
    script.onload = () => {
      setIsLoading(false);
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [siteId]);

  const handleFormSubmit = React.useCallback(
    (e: any) => {
      if (onSubmit) {
        onSubmit(e);
      }
    },
    [onSubmit]
  );

  return (
    <div className='eloqua-form-container'>
      {isLoading && <div className='loading'>Loading form...</div>}
      <form
        method='post'
        name='cle-10162025-639039160594173880-639052118761230618'
        action='https://s958345745.t.eloqua.com/e/f2'
        onSubmit={(e) => onSubmit(e)}
        id='form905'
        className='elq-form'
      >
        <input
          value='cle-10162025-639039160594173880-639052118761230618'
          type='hidden'
          name='elqFormName'
        />
        <input value='958345745' type='hidden' name='elqSiteId' />
        <input name='elqCampaignId' type='hidden' />
        <input
          type='hidden'
          name='hiddenField'
          id='fe9444'
          value='DD_Form_GEO_Calc_Test'
        />
        <input type='hidden' name='hiddenField5' id='fe9449' value='K0221085' />
        <input
          type='hidden'
          name='leadSourceOriginal'
          id='fe9467'
          value='Deloitte Digital'
        />
        <input
          type='hidden'
          name='customData1'
          id='fe9468'
          value='Deloitte Digital'
        />
        <input type='hidden' name='customData2' id='fe9469' value='URL' />
        <input type='hidden' name='hiddenField6' id='fe9450' value='' />
        <Box sx={{ width: '100%', mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label='First Name'
                name='firstName'
                id='fe9436'
                variant='outlined'
                size='small'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label='Last Name'
                name='lastName'
                id='fe9437'
                variant='outlined'
                size='small'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label='Work Email Address'
                name='emailAddress'
                id='fe9438'
                type='email'
                variant='outlined'
                size='small'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label='Title'
                name='title'
                id='fe9439'
                variant='outlined'
                size='small'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label='Company'
                name='accountEntered1'
                id='fe9440'
                variant='outlined'
                size='small'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required variant='outlined' size='small'>
                <InputLabel id='country-label'>Country</InputLabel>
                <Select
                  labelId='country-label'
                  id='fe9441'
                  name='country'
                  label='Country'
                  defaultValue=''
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        bgcolor: 'white',
                        '& .MuiMenuItem-root': {
                          //color: 'black',
                          bgcolor: 'white',
                          '&:hover': {
                            bgcolor: 'rgba(0, 0, 0, 0.04)',
                          },
                          '&.Mui-selected': {
                            bgcolor: 'rgba(0, 0, 0, 0.08)',
                            '&:hover': {
                              bgcolor: 'rgba(0, 0, 0, 0.12)',
                            },
                          },
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value=''>-- Please Select --</MenuItem>
                  <MenuItem value='Afghanistan'>Afghanistan</MenuItem>
                  <MenuItem value='Albania'>Albania</MenuItem>
                  <MenuItem value='Algeria'>Algeria</MenuItem>
                  <MenuItem value='American Samoa '>American Samoa</MenuItem>
                  <MenuItem value='Andorra'>Andorra</MenuItem>
                  <MenuItem value='Angola'>Angola</MenuItem>
                  <MenuItem value='Antigua and Barbuda'>
                    Antigua and Barbuda
                  </MenuItem>
                  <MenuItem value='Argentina'>Argentina</MenuItem>
                  <MenuItem value='Armenia'>Armenia</MenuItem>
                  <MenuItem value='Aruba '>Aruba</MenuItem>
                  <MenuItem value='Australia'>Australia</MenuItem>
                  <MenuItem value='Austria'>Austria</MenuItem>
                  <MenuItem value='Azerbaijan'>Azerbaijan</MenuItem>
                  <MenuItem value='Bahamas'>Bahamas</MenuItem>
                  <MenuItem value='Bahrain'>Bahrain</MenuItem>
                  <MenuItem value='Bangladesh'>Bangladesh</MenuItem>
                  <MenuItem value='Barbados'>Barbados</MenuItem>
                  <MenuItem value='Belarus'>Belarus</MenuItem>
                  <MenuItem value='Belgium'>Belgium</MenuItem>
                  <MenuItem value='Belize'>Belize</MenuItem>
                  <MenuItem value='Benin'>Benin</MenuItem>
                  <MenuItem value='Bermuda '>Bermuda</MenuItem>
                  <MenuItem value='Bhutan'>Bhutan</MenuItem>
                  <MenuItem value='Bolivia'>Bolivia</MenuItem>
                  <MenuItem value='Bonaire, Sint Eustasius and Saba '>
                    Bonaire, Sint Eustasius and Saba
                  </MenuItem>
                  <MenuItem value='Bosnia &amp; Herzegovina'>
                    Bosnia &amp; Herzegovina
                  </MenuItem>
                  <MenuItem value='Botswana'>Botswana</MenuItem>
                  <MenuItem value='Brazil'>Brazil</MenuItem>
                  <MenuItem value='British Virgin Islands '>
                    British Virgin Islands
                  </MenuItem>
                  <MenuItem value='Brunei '>Brunei</MenuItem>
                  <MenuItem value='Bulgaria'>Bulgaria</MenuItem>
                  <MenuItem value='Burkina Faso'>Burkina Faso</MenuItem>
                  <MenuItem value='Burundi'>Burundi</MenuItem>
                  <MenuItem value="CÃ´te d'Ivoire">
                    CÃ´te d&apos;Ivoire
                  </MenuItem>
                  <MenuItem value='Cabo Verde'>Cabo Verde</MenuItem>
                  <MenuItem value='Cambodia'>Cambodia</MenuItem>
                  <MenuItem value='Cameroon'>Cameroon</MenuItem>
                  <MenuItem value='Canada'>Canada</MenuItem>
                  <MenuItem value='Cayman Islands '>Cayman Islands</MenuItem>
                  <MenuItem value='Central African Republic'>
                    Central African Republic
                  </MenuItem>
                  <MenuItem value='Chad'>Chad</MenuItem>
                  <MenuItem value='Chile'>Chile</MenuItem>
                  <MenuItem value='China'>China</MenuItem>
                  <MenuItem value='Colombia'>Colombia</MenuItem>
                  <MenuItem value='Comoros'>Comoros</MenuItem>
                  <MenuItem value='Congo'>Congo</MenuItem>
                  <MenuItem value='Costa Rica'>Costa Rica</MenuItem>
                  <MenuItem value='Croatia'>Croatia</MenuItem>
                  <MenuItem value='Cuba'>Cuba</MenuItem>
                  <MenuItem value='Curacao '>Curacao</MenuItem>
                  <MenuItem value='Cyprus'>Cyprus</MenuItem>
                  <MenuItem value='Czech Republic'>Czech Republic</MenuItem>
                  <MenuItem value='Denmark'>Denmark</MenuItem>
                  <MenuItem value='Djibouti'>Djibouti</MenuItem>
                  <MenuItem value='Dominica'>Dominica</MenuItem>
                  <MenuItem value='Dominican Republic'>
                    Dominican Republic
                  </MenuItem>
                  <MenuItem value='DR Congo'>DR Congo</MenuItem>
                  <MenuItem value='Ecuador'>Ecuador</MenuItem>
                  <MenuItem value='Egypt'>Egypt</MenuItem>
                  <MenuItem value='El Salvador'>El Salvador</MenuItem>
                  <MenuItem value='Equatorial Guinea'>
                    Equatorial Guinea
                  </MenuItem>
                  <MenuItem value='Eritrea'>Eritrea</MenuItem>
                  <MenuItem value='Estonia'>Estonia</MenuItem>
                  <MenuItem value='Ethiopia'>Ethiopia</MenuItem>
                  <MenuItem value='Fiji'>Fiji</MenuItem>
                  <MenuItem value='Finland'>Finland</MenuItem>
                  <MenuItem value='France'>France</MenuItem>
                  <MenuItem value='Gabon'>Gabon</MenuItem>
                  <MenuItem value='Gambia'>Gambia</MenuItem>
                  <MenuItem value='Georgia'>Georgia</MenuItem>
                  <MenuItem value='Germany'>Germany</MenuItem>
                  <MenuItem value='Ghana'>Ghana</MenuItem>
                  <MenuItem value='Gibraltar '>Gibraltar</MenuItem>
                  <MenuItem value='Greece'>Greece</MenuItem>
                  <MenuItem value='Greenland '>Greenland</MenuItem>
                  <MenuItem value='Grenada'>Grenada</MenuItem>
                  <MenuItem value='Guam '>Guam</MenuItem>
                  <MenuItem value='Guatemala'>Guatemala</MenuItem>
                  <MenuItem value='Guernsey'>Guernsey</MenuItem>
                  <MenuItem value='Guinea'>Guinea</MenuItem>
                  <MenuItem value='Guinea-Bissau'>Guinea-Bissau</MenuItem>
                  <MenuItem value='Guyana'>Guyana</MenuItem>
                  <MenuItem value='Haiti'>Haiti</MenuItem>
                  <MenuItem value='Holy See'>Holy See</MenuItem>
                  <MenuItem value='Honduras'>Honduras</MenuItem>
                  <MenuItem value='Hungary'>Hungary</MenuItem>
                  <MenuItem value='Iceland'>Iceland</MenuItem>
                  <MenuItem value='India'>India</MenuItem>
                  <MenuItem value='Indonesia'>Indonesia</MenuItem>
                  <MenuItem value='Iran'>Iran</MenuItem>
                  <MenuItem value='Iraq'>Iraq</MenuItem>
                  <MenuItem value='Ireland'>Ireland</MenuItem>
                  <MenuItem value='Isle of Man '>Isle of Man</MenuItem>
                  <MenuItem value='Israel'>Israel</MenuItem>
                  <MenuItem value='Italy'>Italy</MenuItem>
                  <MenuItem value='Jamaica'>Jamaica</MenuItem>
                  <MenuItem value='Japan'>Japan</MenuItem>
                  <MenuItem value='Jordan'>Jordan</MenuItem>
                  <MenuItem value='Kazakhstan'>Kazakhstan</MenuItem>
                  <MenuItem value='Kenya'>Kenya</MenuItem>
                  <MenuItem value='Kiribati'>Kiribati</MenuItem>
                  <MenuItem value='Kuwait'>Kuwait</MenuItem>
                  <MenuItem value='Kyrgyzstan'>Kyrgyzstan</MenuItem>
                  <MenuItem value='Laos'>Laos</MenuItem>
                  <MenuItem value='Latvia'>Latvia</MenuItem>
                  <MenuItem value='Lebanon'>Lebanon</MenuItem>
                  <MenuItem value='Lesotho'>Lesotho</MenuItem>
                  <MenuItem value='Liberia'>Liberia</MenuItem>
                  <MenuItem value='Libya'>Libya</MenuItem>
                  <MenuItem value='Liechtenstein'>Liechtenstein</MenuItem>
                  <MenuItem value='Lithuania'>Lithuania</MenuItem>
                  <MenuItem value='Luxembourg'>Luxembourg</MenuItem>
                  <MenuItem value='Madagascar'>Madagascar</MenuItem>
                  <MenuItem value='Malawi'>Malawi</MenuItem>
                  <MenuItem value='Malaysia'>Malaysia</MenuItem>
                  <MenuItem value='Maldives'>Maldives</MenuItem>
                  <MenuItem value='Mali'>Mali</MenuItem>
                  <MenuItem value='Malta'>Malta</MenuItem>
                  <MenuItem value='Marshall Islands'>Marshall Islands</MenuItem>
                  <MenuItem value='Mauritania'>Mauritania</MenuItem>
                  <MenuItem value='Mauritius'>Mauritius</MenuItem>
                  <MenuItem value='Mexico'>Mexico</MenuItem>
                  <MenuItem value='Micronesia'>Micronesia</MenuItem>
                  <MenuItem value='Moldova'>Moldova</MenuItem>
                  <MenuItem value='Monaco'>Monaco</MenuItem>
                  <MenuItem value='Mongolia'>Mongolia</MenuItem>
                  <MenuItem value='Montenegro'>Montenegro</MenuItem>
                  <MenuItem value='Morocco'>Morocco</MenuItem>
                  <MenuItem value='Mozambique'>Mozambique</MenuItem>
                  <MenuItem value='Myanmar'>Myanmar</MenuItem>
                  <MenuItem value='Namibia'>Namibia</MenuItem>
                  <MenuItem value='Nauru'>Nauru</MenuItem>
                  <MenuItem value='Nepal'>Nepal</MenuItem>
                  <MenuItem value='Netherlands'>Netherlands</MenuItem>
                  <MenuItem value='New Zealand'>New Zealand</MenuItem>
                  <MenuItem value='Nicaragua'>Nicaragua</MenuItem>
                  <MenuItem value='Niger'>Niger</MenuItem>
                  <MenuItem value='Nigeria'>Nigeria</MenuItem>
                  <MenuItem value='North Korea'>North Korea</MenuItem>
                  <MenuItem value='Northern Mariana Islands '>
                    Northern Mariana Islands
                  </MenuItem>
                  <MenuItem value='Norway'>Norway</MenuItem>
                  <MenuItem value='Oman'>Oman</MenuItem>
                  <MenuItem value='Pakistan'>Pakistan</MenuItem>
                  <MenuItem value='Palau'>Palau</MenuItem>
                  <MenuItem value='Panama'>Panama</MenuItem>
                  <MenuItem value='Papua New Guinea'>Papua New Guinea</MenuItem>
                  <MenuItem value='Paraguay'>Paraguay</MenuItem>
                  <MenuItem value='Peru'>Peru</MenuItem>
                  <MenuItem value='Philippines'>Philippines</MenuItem>
                  <MenuItem value='Poland'>Poland</MenuItem>
                  <MenuItem value='Portugal'>Portugal</MenuItem>
                  <MenuItem value='Qatar'>Qatar</MenuItem>
                  <MenuItem value='Romania'>Romania</MenuItem>
                  <MenuItem value='Russia'>Russia</MenuItem>
                  <MenuItem value='Rwanda'>Rwanda</MenuItem>
                  <MenuItem value='Saint Kitts &amp; Nevis'>
                    Saint Kitts &amp; Nevis
                  </MenuItem>
                  <MenuItem value='Saint Lucia'>Saint Lucia</MenuItem>
                  <MenuItem value='Samoa'>Samoa</MenuItem>
                  <MenuItem value='San Marino'>San Marino</MenuItem>
                  <MenuItem value='Sao Tome &amp; Principe'>
                    Sao Tome &amp; Principe
                  </MenuItem>
                  <MenuItem value='Saudi Arabia'>Saudi Arabia</MenuItem>
                  <MenuItem value='Senegal'>Senegal</MenuItem>
                  <MenuItem value='Serbia'>Serbia</MenuItem>
                  <MenuItem value='Seychelles'>Seychelles</MenuItem>
                  <MenuItem value='Sierra Leone'>Sierra Leone</MenuItem>
                  <MenuItem value='Singapore'>Singapore</MenuItem>
                  <MenuItem value='Slovakia'>Slovakia</MenuItem>
                  <MenuItem value='Slovenia'>Slovenia</MenuItem>
                  <MenuItem value='Solomon Islands'>Solomon Islands</MenuItem>
                  <MenuItem value='Somalia'>Somalia</MenuItem>
                  <MenuItem value='South Africa'>South Africa</MenuItem>
                  <MenuItem value='South Korea'>South Korea</MenuItem>
                  <MenuItem value='South Sudan'>South Sudan</MenuItem>
                  <MenuItem value='Spain'>Spain</MenuItem>
                  <MenuItem value='Sri Lanka'>Sri Lanka</MenuItem>
                  <MenuItem value='St. Maarten '>St. Maarten</MenuItem>
                  <MenuItem value='St. Vincent &amp; Grenadines'>
                    St. Vincent &amp; Grenadines
                  </MenuItem>
                  <MenuItem value='State of Palestine'>
                    State of Palestine
                  </MenuItem>
                  <MenuItem value='Sudan'>Sudan</MenuItem>
                  <MenuItem value='Suriname'>Suriname</MenuItem>
                  <MenuItem value='Swaziland'>Swaziland</MenuItem>
                  <MenuItem value='Sweden'>Sweden</MenuItem>
                  <MenuItem value='Switzerland'>Switzerland</MenuItem>
                  <MenuItem value='Syria'>Syria</MenuItem>
                  <MenuItem value='Tajikistan'>Tajikistan</MenuItem>
                  <MenuItem value='Tanzania'>Tanzania</MenuItem>
                  <MenuItem value='TFYR Macedonia'>TFYR Macedonia</MenuItem>
                  <MenuItem value='Thailand'>Thailand</MenuItem>
                  <MenuItem value='Timor-Leste'>Timor-Leste</MenuItem>
                  <MenuItem value='Togo'>Togo</MenuItem>
                  <MenuItem value='Tonga'>Tonga</MenuItem>
                  <MenuItem value='Trinidad and Tobago'>
                    Trinidad and Tobago
                  </MenuItem>
                  <MenuItem value='Tunisia'>Tunisia</MenuItem>
                  <MenuItem value='Turkey'>Turkey</MenuItem>
                  <MenuItem value='Turkmenistan'>Turkmenistan</MenuItem>
                  <MenuItem value='Turks and Caicos '>
                    Turks and Caicos
                  </MenuItem>
                  <MenuItem value='Tuvalu'>Tuvalu</MenuItem>
                  <MenuItem value='Uganda'>Uganda</MenuItem>
                  <MenuItem value='Ukraine'>Ukraine</MenuItem>
                  <MenuItem value='United Arab Emirates'>
                    United Arab Emirates
                  </MenuItem>
                  <MenuItem value='United Kingdom'>United Kingdom</MenuItem>
                  <MenuItem value='United States'>United States</MenuItem>
                  <MenuItem value='Uruguay'>Uruguay</MenuItem>
                  <MenuItem value='US Virgin Islands '>
                    US Virgin Islands
                  </MenuItem>
                  <MenuItem value='Uzbekistan'>Uzbekistan</MenuItem>
                  <MenuItem value='Vanuatu'>Vanuatu</MenuItem>
                  <MenuItem value='Venezuela'>Venezuela</MenuItem>
                  <MenuItem value='Vietnam'>Vietnam</MenuItem>
                  <MenuItem value='Yemen'>Yemen</MenuItem>
                  <MenuItem value='Zambia'>Zambia</MenuItem>
                  <MenuItem value='Zimbabwe'>Zimbabwe</MenuItem>
                  <MenuItem value='Other'>Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl component='fieldset' required>
                <Typography variant='body2' sx={{ mb: 1 }}>
                  I agree to receive emailed reports, articles, and event
                  invitations. I understand I may unsubscribe *
                </Typography>
                <RadioGroup name='radioButtons' id='fe9442'>
                  <FormControlLabel
                    value='Yes'
                    control={<Radio id='radio-Yes_tvikyhi7' />}
                    label='Yes'
                  />
                  <FormControlLabel
                    value='No'
                    control={<Radio id='radio-No_98x6u54m' />}
                    label='No'
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox name='singleCheckbox' id='fe9443' required />
                }
                label='Terms and Conditions *'
                sx={{
                  justifyContent: 'flex-start',
                  mr: 'auto',
                  width: '100%',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <StyledButton
                type='submit'
                background={design.colors.button}
                $buttonColor={design.colors.buttonText}
                highlight={design.colors.buttonActive}
                width='157px'
                style={{ margin: 0 }}
              >
                Submit
              </StyledButton>
            </Grid>
          </Grid>
        </Box>
      </form>
    </div>
  );
};

export default EloquaForm;
